// removed by extract-text-webpack-plugin
module.exports = {"poster-card-wrapper":"poster-card-wrapper","poster-card":"poster-card","image-wrapper":"image-wrapper","image-overlay":"image-overlay","image":"image","poster-content":"poster-content","date":"date","title":"title","published":"published","draft":"draft","poster-type":"poster-type","setting-section":"setting-section","setting-content":"setting-content","poster-button":"poster-button","button":"button","poster-state":"poster-state","card-button":"card-button"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Poster/PosterList/PosterCard.scss
// module id = JJH7
// module chunks = 0